import { gql } from '@apollo/client';
import { CONTENT_BLOCK } from '../content';
import { IMAGE_BLOCK } from '../image';
import { SPACER_BLOCK } from '../Spacer';
import { CARD_WITH_BLOCKS } from '../card';
import { VERTICAL_SLIDER_BLOCK } from '../verticalSlider';
import { ANIMATED_TEXT_BLOCK } from '../animatedTextBlock';
import { BLOCK_SETTINGS_FIELD } from '../../fields';
import { SLIDER_WITH_BLOCKS } from '../sliderWithBlocks';
import { FORM_BLOCK } from '../form';
import { FAQ_BLOCK } from '../faq';

export const COLUMNS_BLOCK = gql`
  fragment ColumnsBlockFragment on Columns {
    blockSettings {
      ...BlockSettingsFieldFragment
    }
    settings {
      verticalAlignment
      columnGapSize
      flipOnMobile
    }
    columns {
      id
      columnWidth
      blocks {
        ...AnimatedTextBlockFragment
        ...CardWithBlocksFragment
        ...ContentBlockFragment
        ...ImageBlockFragment
        ...SpacerBlockFragment
        ...VerticalSliderBlockFragment
        ...SliderWithBlocksFragment
        ...FormBlockFragment
        ...FaqBlockFragment
      }
    }
    id
    blockName
    blockType
  }
  ${ANIMATED_TEXT_BLOCK}
  ${CARD_WITH_BLOCKS}
  ${CONTENT_BLOCK}
  ${IMAGE_BLOCK}
  ${SPACER_BLOCK}
  ${VERTICAL_SLIDER_BLOCK}
  ${BLOCK_SETTINGS_FIELD}
  ${SLIDER_WITH_BLOCKS}
  ${FORM_BLOCK}
  ${FAQ_BLOCK}
`;
